import React, { useState, useContext, useEffect, useRef } from 'react';

import { FormTextInput } from '../../Components/FormTextInput';

import { useScreenTransition } from '../../Hooks/useScreenTransition';

import { AuthContext } from '../../Context/AuthContext';
import { NotificationContext } from '../../Context/NotificationContext';
import { DataContext } from '../../Context/DataContext';

import './OrderContact.css';
import TopBar from '../../Components/TopBar';
import SecureAndPrivate from '../../NewComponents/SecureAndPrivate';
import NewButton from '../../NewComponents/NewButton';
import CreateOrderNav from '../../NewComponents/CreateOrderNav';
import LogoAuthNavbar from '../../NewComponents/LogoAuthNavbar';
import SignInForm from '../SignIn/SignInForm';
import CreateAccount from '../CreateAccount/CreateAccount';
import OrderSummary from './components/OrderSummary';
import { auth, firestore } from '../../firebase.config';
import { getCounter } from '../../Data/Functions/getCounter';
import { HowDidYouHearAboutUs } from '../../Data/Functions/HowDidYouHear';

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const emailRegex = new RegExp("^[a-zA-Z0-9._+%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,}(\\.?[a-z]{2})?$");



const OrderContact = ({ windowSize }) => {

  const { transitionTo } = useScreenTransition();
  const { showNotification } = useContext(NotificationContext);

  const { signedIn } = useContext(AuthContext);

  const { order, setOrder, userData, teamData } = useContext(DataContext);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [invalidEmail, setInvalidEmail] = useState(false);

  const [submitButton, setSubmitButton] = useState('Continue to Payment');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen] = useState(false);
  const [discount, setDiscount] = useState(0);

  const [showHowDidYouHear, setShowHowDidYouHear] = useState(false);

  const [selectedOption, setSelectedOption] = useState("");
  const [showInputOption, setShowInputOption] = useState(false);
  const [optionInput, setOptionInput] = useState("");

  const inputRef = useRef(null);

  const handleLoginOpen = (newState) => {
    setIsModalOpen(newState);
  }

  const handleCreateAccountOpen = (newState) => {
    setIsCreateAccountOpen(newState);
  }

  useEffect(() => {
    if (order.parsed && (order.type === '')) {
      transitionTo('/order/type');
    } else if (order.parsed && (order.orderID === '' || !order.languageFrom || order.languageFrom === '' || !order.languageTo || order.languageTo === '' || !order.files || order.files.length === 0)) {
      transitionTo('/order/documents');
    }else if(order.parsed && order.type){
      // if (signedIn && userData){
      //   goToPayments();
      // }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order]);

    useEffect(() => {
         if (userData && userData.teamId && teamData) {
           setDiscount(teamData.discount || 0);
         }
     
         // eslint-disable-next-line react-hooks/exhaustive-deps
       }, [userData, teamData]);

  useEffect(() => {

    if (signedIn && auth.currentUser && userData) {
      const first = userData.firstName ? userData.firstName : userData.name;
      const last = userData.lastName ? userData.lastName : "";
      localStorage.setItem('order', JSON.stringify({ ...order, files: JSON.stringify(order.files.filter(f => f.ref && f.url && f.status === 'complete').map(file => ({ name: file.name, ref: file.ref, url: file.url, type: 'source', size: file.file ? file.file.size : file.size, format: file.file ? file.file.type : file.format, status: 'complete', progress: 100, timestamp: file.timestamp }))), firstName: first, lastName: last, name: userData.name, email: userData.email.toLowerCase() }));
      setOrder(q => ({ ...q, firstName: first, lastName: last, name: userData.name, email: userData.email.toLowerCase() }));
      setEmail(userData.email);
      setFirstName(first);
      setLastName(last);
    } else {
      sleep(100).then(() => {
        if (signedIn && auth.currentUser && userData) {
          const first = userData.firstName ? userData.firstName : userData.name;
          const last = userData.lastName ? userData.lastName : "";
          localStorage.setItem('order', JSON.stringify({ ...order, files: JSON.stringify(order.files.filter(f => f.ref && f.url && f.status === 'complete').map(file => ({ name: file.name, ref: file.ref, url: file.url, type: 'source', size: file.file ? file.file.size : file.size, format: file.file ? file.file.type : file.format, status: 'complete', progress: 100, timestamp: file.timestamp }))), firstName: first, lastName: last, name: userData.name, email: userData.email.toLowerCase() }));
          setOrder(q => ({ ...q, firstName: first, lastName: last, name: userData.name, email: userData.email.toLowerCase() }));
          setEmail(userData.email);
          setFirstName(first);
          setLastName(last);
        }
      })
    }

    if (!signedIn && order) {
      setFirstName(order.firstName || "");
      setLastName(order.lastName || "");
      setEmail(order.email || "");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signedIn, userData]);


  // useEffect(() => {
  //   if(order.parsed && order.type && email && firstName){
  //     if (signedIn && userData){
  //       goToPayments();
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [order, email, firstName]);


  const checkHowDidYouHearInDB = async () => {
    firestore.collection("howDidTheyHear").where("email", "==", email).get().then((qSnap) => {
      if(qSnap.empty){
        return;
      }
      const doc = qSnap.docs[0];
      if(doc.exists){
        const {selectedOption, hasInput, inputText} = doc.data().howDidYouHear;
        setSelectedOption(selectedOption);
        setOptionInput(inputText);
        setShowInputOption(hasInput);
      }
    });

  }

  useEffect(() => {
    const howDidYourHearAnswered = JSON.parse(localStorage.getItem("howDidYouHear"));
    setShowHowDidYouHear(!howDidYourHearAnswered || (howDidYourHearAnswered && !howDidYourHearAnswered.selectedOption));

    if(order.howDidYouHear){
      const {selectedOption, hasInput, inputText} = order.howDidYouHear;
      setSelectedOption(selectedOption);
      setOptionInput(inputText);
      setShowInputOption(hasInput);
    }else{
      checkHowDidYouHearInDB();
    }
  }, [order, email])


  const goToPayments = async (e) => {
    const now = new Date();

    
    setSubmitButton('Continuing...');

    if (emailRegex.test(email.toLowerCase())) {

      let orderNumber = 0;

      if (!order.orderNumber) {

        await getCounter("order").then((number) => {
          orderNumber = parseInt(number, 10);
          })
        .catch((error) => {
          //console.log(error);
        });

        if (orderNumber === 0) {
          showNotification('Error', "An error ocurred while processing the request. Please, try again. If it persists, contact support.", 'error');
          setSubmitButton('Continue to Payment');
          return false;
        }
      }

      localStorage.setItem('order', JSON.stringify({ ...order, orderNumber: order.orderNumber ? order.orderNumber : orderNumber, files: JSON.stringify(order.files.filter(f => f.ref && f.url && f.status === 'complete').map(file => ({ name: file.name, ref: file.ref, url: file.url, type: 'source', size: file.file ? file.file.size : file.size, format: file.file ? file.file.type : file.format, status: 'complete', progress: 100, timestamp: file.timestamp }))), firstName: firstName, lastName: lastName, name: `${firstName} ${lastName}`, email: email.toLowerCase() 
      ,howDidYouHear: {selectedOption, hasInput: showInputOption, inputText: optionInput},
        }));
      setOrder(q => ({ ...q, orderNumber: order.orderNumber ? order.orderNumber : orderNumber, firstName, lastName, email: email.toLowerCase(), name: `${firstName} ${lastName}` 
        ,howDidYouHear: {selectedOption, hasInput: showInputOption, inputText: optionInput},
        }));

      const data = {
        orderNumber: orderNumber || order.orderNumber,
        userID: signedIn ? auth.currentUser.uid : '',
        teamId: signedIn ? (userData.teamId || '') : '',
        email: signedIn ? (userData?.email || auth.currentUser.email) : email.toLowerCase(),
        name: `${firstName} ${lastName}`,
        timestamp: now.getTime(),
        status: 'created',
        totalPrice: order.totalPrice,
        discount: discount || 0,
        discountApplied: discount > 0,
        firstName: firstName,
        lastName: lastName,
        certified: order.certified,
        languageFrom: order.languageFrom,
        languageTo: order.languageTo,
        notarization: order.notarization,
        notarizationStatus: order.notarization ? 'pending' : null,
        expedited: order.expedited,
        hardCopy: order.hardCopy,
        hardCopyStatus: order.hardCopy ? 'pending' : null,
        hardCopyExtra: order.hardCopy ? order.hardCopyExtra : null,
        pagesCount: order.pagesCount ? order.pagesCount : 0,
        wordCount: 0,
        files: order.files.map(file => ({ name: file.name, ref: file.ref, url: file.url, type: file.type, size: file.size, format: file.format, timestamp: file.timestamp })),
        notified: false,
        userNotes: '',
        type: order.type,
        generalNotes: order.generalNotes,
        notes: order.generalNotes,
        clientFirstName: order.clientFirstName,
        clientLastName: order.clientLastName,
        howDidYouHear: {selectedOption: selectedOption??"", hasInput: showInputOption??false, inputText: optionInput??""},
      }

      firestore.collection('orders').doc(order.orderID)
        .set(data)
        .then(() => {
          setSubmitButton('Continue to Payment');
          transitionTo('/order/payment');
        })
        .catch(error => {
          console.log(error)
          setSubmitButton('Continue to Payment');
          showNotification('Error', "An error ocurred while placing the order. Please, try again.", 'error');
        })
    } else {
      setInvalidEmail(true);
      setSubmitButton('Continue to Payment');
      showNotification("Invalid Email", "The email address is invalid. Please, try again.", "error");
    }
  };

  const triggerEnter = () => {
    if (!(firstName === "" || email === "")) {
      goToPayments();
    }
  }

  const phoneScreen = windowSize.orientation === 'portrait' && windowSize.width <= 767;

  const handleEmailChange = (value) => {
    setEmail(value);
    setInvalidEmail(false);
  }

  const onClickOption = (option) => {
    setSelectedOption(option.value);
    setShowInputOption(option.extraInput??false);
    setOptionInput("");
    inputRef.current && inputRef.current.focus();
  }

  const checkHearOption = () => {
    if(!showHowDidYouHear){
      return false;
    }
    return (!signedIn && !userData && order.type === "personal") ? selectedOption === "" ? true : showInputOption ? !optionInput : false : false;
  }
 
  return (
    <>
      <TopBar />
      <SignInForm open={isModalOpen} isLoginFormOpen={handleLoginOpen} isCreateAccountOpen={handleCreateAccountOpen} pageRedirect={false} />
      <CreateAccount open={isCreateAccountOpen} isCreateAccountOpen={handleCreateAccountOpen} isLoginFormOpen={handleLoginOpen} accountType={order.type} showSelectAccountType={false} width='420px' />

      <div className="mainOrderContainer">
        <div className="mainOrderHeader">
          <LogoAuthNavbar isAuth={signedIn} showButtons={false} />
        </div>
        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <CreateOrderNav title="4. Contact" stage={4} />
            <div></div>
          </div>
        </div>
        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <div id="mainPrimary" className="mainOrderPrimaryContent">
              <div className="quotePrimaryOptionsWrapper">
                <h4 className="quotePrimaryTitle">Your Contact</h4>
                <div className='orderInputWrapper'>
                  <div className="quoteDetailsInputsContainer">
                    <FormTextInput disabled={signedIn} placeholder="First Name" value={firstName} onChange={setFirstName} onKeyDown={(e) => e.key === "Enter" && triggerEnter()} />
                    <FormTextInput disabled={signedIn} placeholder="Last Name" value={lastName} onChange={setLastName} onKeyDown={(e) => e.key === "Enter" && triggerEnter()} />
                  </div>
                  <FormTextInput incorrect={invalidEmail} clearInputIcon={true} disabled={signedIn} placeholder="Email" value={email} onChange={handleEmailChange} onKeyDown={(e) => e.key === "Enter" && triggerEnter()} />
                  {!signedIn && <div className='orderLinkContainer'>
                    <div className='orderSimpleTextLink' onClick={() => setIsCreateAccountOpen(true)}>Create an Account</div>
                    <div className='orderSimpleText'>If you have an account <span className='link' onClick={() => setIsModalOpen(true)}>Sign in</span></div>
                  </div>}
                  {!signedIn && <p className="quoteExtraMessage">Creating an account allows you to access your quote and order history, saved addresses, payment methods, and site preferences anytime.</p>}
                </div>

              </div>

              {showHowDidYouHear && !signedIn && !userData && order.type === "personal" &&
              <div className="quotePrimaryOptionsWrapper">
                <h4 className="quotePrimaryTitle">How did you hear about us?</h4>
                <div className='flex flex-wrap gap-[8px] mt-4'>
                  {HowDidYouHearAboutUs.map((option, i) => 
                     <div key={option.value} className={`relative flex justify-start items-center gap-2 min-w-[200px] overflow-hidden transition-all duration-300
                      bg-[#fff] rounded-[8px] ${showInputOption && selectedOption === option.value  ? "px-[16px] pt-[16px] pb-[8px]" : "px-[16px] py-[16px]"} cursor-pointer hover:border-[#12ABBF]  min-h-[54px]
                      ${selectedOption === option.value ? 'border-[#12ABBF] border-[2px] ' : 'border-[#E6E7E9] border-[1px]'} "w-max" max-sm:w-full`} onClick={() => onClickOption(option)}>
                         {option.icon && <img src={option.icon} alt={""} className='w-[24px] h-[24px]'/> }
                         <p className={`${showInputOption && selectedOption === option.value ? `transition-all duration-300 absolute text-[#686f7b] ${selectedOption === option.value ? "text-[12px] weight-[400] top-[4px] left-[8px]" : "top-[18px] left-[16px] onBoarding-description"}` : "onBoarding-description"}`}>
                          {option.label}
                          </p> 
                          {showInputOption && selectedOption === option.value && 
                          <input ref={inputRef} type="text" autoFocus className={`${i === 4 ? "w-[218px]": i === 5 ? "w-[287px]" : "w-full"} min-w-[160px] h-[18px] border-[0] outline-none bg-transparent text-[14px] weight-[400]`} placeholder={option.extraInputLabel?? "Please specify"} value={optionInput} onChange={(e) => setOptionInput(e.target.value)} onClick={(e) => e.stopPropagation()}/>
                        }
                    </div>
                  )}
                </div>
              </div>
              }

              <div>
                {!phoneScreen && <div className="quoteSubmitButtonContainer">
                  <NewButton text="Back to Options" onClick={(e) => transitionTo('/order/options', e)} back={true} />
                  <NewButton text={submitButton} disabled={(firstName === "" || email === "" || checkHearOption())} onClick={() => goToPayments()} />
                </div>}
              </div>
            </div>
          </div>

          <div className='mainOrderSecondaryContent'>
            <div className='mainOrderSecondaryContentWrap'>
              <OrderSummary order={order} certified={order.certified} pagesCount={order.pagesCount} languageFrom={order.languageFrom} languageTo={order.languageTo} />
              <div>
                <SecureAndPrivate order={order} />
                {phoneScreen && <div className="quoteSubmitButtonContainer">
                  <NewButton text="Back to Services" onClick={(e) => transitionTo('/order/options', e)} back={true} />
                  <NewButton text={submitButton} disabled={(firstName === "" || email === "" || checkHearOption())} onClick={() => goToPayments()} />
                </div>}
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}

export default OrderContact;